import Tab from "components/Tab";
import ListNoNextLine from "../../../../contents/handbook/content/_snippets/list-no-nextline.md";
import ListNoNextMarkdown from "../../../../contents/handbook/content/_snippets/list-no-nextline-md.md";
import ListWithNextLine from "../../../../contents/handbook/content/_snippets/list-with-nextline.md";
import ListWithNextMarkdown from "../../../../contents/handbook/content/_snippets/list-with-nextline-md.md";
import * as React from 'react';
export default {
  Tab,
  ListNoNextLine,
  ListNoNextMarkdown,
  ListWithNextLine,
  ListWithNextMarkdown,
  React
};